module.exports = __webpack_public_path__ + "img/RectangleOrange.58e263f5.svg";